import { AxiosRequestConfig } from "axios";

import HttpHandler, { HttpError } from "./httpHandler";
import { log } from "./logger";

export class Handlers {
	static authError = (message: string) => {
		log(message, "error");
	};
}

/**
 * Make a POST request to the TLP server
 * @param controller
 * @param action
 * @param params
 * @param data
 * @param config
 */
export async function Post<TOut, TIn = any>(
	controller: string,
	action: string,
	params: object | string = {},
	data?: TIn,
	config?: AxiosRequestConfig,
) {
	try {
		return await HttpHandler.Post<TOut, TIn>(buildUrl(controller, action), params, data, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

export async function Put<TOut, TIn = any>(
	controller: string,
	action: string,
	params: object | string = {},
	data?: TIn,
	config?: AxiosRequestConfig,
) {
	try {
		return await HttpHandler.Put<TOut, TIn>(buildUrl(controller, action), params, data, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

/**
 * Make a GET request to the TLP server
 * @param controller
 * @param action
 * @param params
 */
export async function Get<TOut>(controller: string, action: string, params: object | string = {}) {
	try {
		return await HttpHandler.Get<TOut>(buildUrl(controller, action), params);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}
export async function Ping<TOut>(controller: string, action: string) {
	try {
		return await HttpHandler.Ping<TOut>(buildUrl(controller, action));
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

export async function Delete<TOut>(controller: string, action: string, id: number) {
	try {
		return await HttpHandler.Delete<TOut>(buildUrl(controller, action), id);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

/**
 * Combine the controller and action into a URL
 * @param controller
 * @param action
 */
function buildUrl(controller: string, action: string) {
	return controller + (action ? `/${action}` : "");
}

const httpError = (error: HttpError) => {
	switch (error.status) {
		case 401:
			Handlers.authError(error.message);
			break;
	}
};

export type { HttpError } from "./httpHandler";

export default { Post, Put, Get, Delete, Ping, Handlers };
